import { FaVolleyballBall } from 'react-icons/fa'
import { FaBug } from 'react-icons/fa'
import { FaCar } from 'react-icons/fa'
import { FaRegMoon } from 'react-icons/fa'
import { FaSun } from 'react-icons/fa'
import { FaAnchor } from 'react-icons/fa'
import { FaFlask } from 'react-icons/fa'
import { FaLaptopCode } from 'react-icons/fa'
import { FaHandSpock } from 'react-icons/fa'

export const icons = [
  { icon: <FaVolleyballBall />, value: 'volleyBall' },
  { icon: <FaBug />, value: 'bug' },
  { icon: <FaCar />, value: 'car' },
  { icon: <FaRegMoon />, value: 'moon' },
  { icon: <FaSun />, value: 'sun' },
  { icon: <FaAnchor />, value: 'anchor' },
  { icon: <FaFlask />, value: 'flask' },
  { icon: <FaLaptopCode />, value: 'laptopCode' },
  { icon: <FaHandSpock />, value: 'laptopCode' },
]
